import React from "react";
import { IDataMasking } from "@/IDataMaskingParagraph";

const DataMaskingParagraph = ({dataMasking}: IDataMasking): JSX.Element =>
(<>
    <div className={`dataMaskingInlineWrapper bg-color-gray-background spacing-sm-p-4 spacing-p-8`}>
        <div className={`dataMaskingInlineFullLockBox`}>
            <div className={`dataMaskingInlineLockIcon`} />

            <div className={`dataMaskingInlineText`}>
                <p className={`heading-5`}>
                    {dataMasking.maskHeadingLocalized ?? "Unlock more company and contact details with your D&B Hoovers Free Trial"}

                </p>

                <p className={`lead`}>
                   {dataMasking.maskContentLocalized ?? "Find and prioritize your best prospects, boost your sales productivity, and win more deals with D&B Hoovers."}
                </p>
            </div>
        </div>

        <div className="text-center">
            <a
                className={`button-primary`}
                href={dataMasking.hooversFreeTrialDirectoryPathRewritten}
                // onClick={trackDataMaskingInlineCta}
                >
                {dataMasking.maskButtonLocalized ?? "Get a D&B Hoovers Free Trial"}
            </a>
        </div>
    </div>
</>);
export default DataMaskingParagraph;



